import PropTypes from "prop-types";

import i18n from "../../../i18n";

import SplitButton from "../SplitButton";

import useEquipmentService from "../../../services/equipmentService";

import { useAsyncFn } from "../../../hooks/useAsync";

import { useSnackbarAlert } from "../../../context/snackbarAlert";

function ChangeElectricityDistributionApprovedByDcButton(props) {
  const snackbarAlert = useSnackbarAlert();

  const { changeElectricityDistributionApprovedByDc } = useEquipmentService();
  const changeElectricityDistributionApprovedByDcFn = useAsyncFn(
    changeElectricityDistributionApprovedByDc
  );

  const handleChangeElectricityDistributionAcceptanceButton = (
    acceptanceValue
  ) => {
    if (props.selectedElectricityDistributionIds.length === 0) return;

    changeElectricityDistributionApprovedByDcFn
      .execute(props.selectedElectricityDistributionIds, acceptanceValue)
      .then(() => {
        if (props.onSubmit) props.onSubmit();
        snackbarAlert.openSuccessSnackbarAlert(
          i18n.t("snackbar_alert.saved_changes")
        );
      })
      .catch(() => {
        snackbarAlert.openErrorSnackbarAlert(
          i18n.t("snackbar_alert.occurred_error_during_saving_changes")
        );
      });
  };

  const massActions = [
    {
      label: i18n.t(`true`),
      callback: () => handleChangeElectricityDistributionAcceptanceButton(true),
    },
    {
      label: i18n.t(`false`),
      callback: () =>
        handleChangeElectricityDistributionAcceptanceButton(false),
    },
  ];

  return (
    <>
      <SplitButton
        label={i18n.t("bar.tool_bar.ed_is_approved_by_dc")}
        withChangeSelectedItem={false}
        color={props.color}
        options={massActions}
      />
    </>
  );
}

ChangeElectricityDistributionApprovedByDcButton.propTypes = {
  color: PropTypes.string,
  selectedElectricityDistributionIds: PropTypes.array,
  onSubmit: PropTypes.func,
};

ChangeElectricityDistributionApprovedByDcButton.defaultProps = {
  color: "success",
  selectedElectricityDistributionIds: [],
};

export default ChangeElectricityDistributionApprovedByDcButton;
